// components/SidebarMenu.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
// import "./SidebarMenu.scss"; // optional if styles are separate

function SidebarMenu() {
  const [openSections, setOpenSections] = useState({});

  // components/SidebarMenu.jsx
  const menuItems = [
    {
      title: "Customers",
      children: [
        {
          to: "/home/findCustomer",
          label: "Customer",
          className: "customerIcon",
        },
        {
          to: "/home/allCustomer",
          label: "Customers’ List",
          className: "allCustomer",
        },
        {
          to: "/home/shopifyMerchants",
          label: "Shopify Merchants",
          className: "businessCustomerIcon",
        },
        {
          to: "/home/couponList",
          label: "Promo Code and Coupons",
          className: "couponsIcon",
        },
        {
          to: "/home/businessCustomer",
          label: "Add a Business Customers",
          className: "businessCustomerIcon",
        },
      ],
    },
    {
      title: "Orders",
      children: [
        {
          to: "/home/activeOrders",
          label: "Active Orders",
          className: "transportIcon",
        },
        {
          to: "/home/reservedOrders",
          label: "Reserved Orders",
          className: "transportIcon",
        },
        {
          to: "/home/completedOrders",
          label: "Completed Orders",
          className: "transportIcon",
        },
        {
          to: "/home/findTransport",
          label: "Transports (Orders)",
          className: "transportIcon",
        },
        {
          to: "/home/assignmentTransports",
          label: "Incomplete Job Assignments",
          className: "incomplete-assignments",
        },
        {
          to: "/home/AutoAssignedTransportList",
          label: "Auto Assigned Transports’ List",
          className: "auto-assigned-transport-list",
        },
      ],
    },
    {
      title: "Bundled Orders",
      children: [
        {
          to: "/home/bundleTransport",
          label: "Create Bundles",
          className: "transportIcon",
        },
        {
          to: "/home/findBundleOrder",
          label: "Search in Bundles",
          className: "transportIcon",
        },
        {
          to: "/home/bundledOrderList",
          label: "Bundled Orders’ List",
          className: "transportIcon",
        },
        {
          to: "/home/activeBundles",
          label: "Active Bundles",
          className: "transportIcon",
        },
      ]
    },
    {
      title: "Bearers",
      children: [
        { to: "/home/findRider", label: "Bearers", className: "riderIcon" },
        {
          to: "/home/allNewRiders",
          label: "Bearers’ List",
          className: "bearer-list",
        },
        {
          to: "/home/allRiders",
          label: "Verify Bearers",
          className: "verify-bearers",
        },
        {
          to: "/home/onlineBearers",
          label: "Online Bearers",
          className: "onlineBearerIcon",
        },
        {
          to: "/home/FailedTransferPayment",
          label: "Failed Payment",
          className: "bearer-list",
        },
        {
          to: "/home/manualReviewVerifyRTW",
          label: "Manual RTW Update",
          className: "verify-bearers",
        },
        {
          to: "/home/nccDocumentVerification",
          label: "NCC Documents’ Verification",
          className: "ncc-document-verification",
        },
        {
          to: "/home/BatchRiderBonusUpdate",
          label: "Batch Bearers’ Bonus Update",
          className: "batch-rider-bonus-update",
        },
      ],
    },
    {
      title: "Vehicles",
      children: [
        { to: "/home/findCar", label: "Cars", className: "car-icon" },
        { to: "/home/carLists", label: "Car List", className: "car-list-icon" },
        {
          to: "/home/findMotorbike",
          label: "Motorbikes",
          className: "motorbikeIcon",
        },
        {
          to: "/home/motorbikeLists",
          label: "Motorbike List",
          className: "motorbike-list-icon",
        },
      ],
    },
    {
      title: "Platform Settings",
      children: [
        {
          to: "/home/parcelList",
          label: "Parcel Details",
          className: "parcelIcon",
        },
        {
          to: "/home/pricingObject",
          label: "Pricing Object",
          className: "priceIcon",
        },
      ],
    },
    {
      title: "Communications",
      children: [
        { to: "/home/sendSMS", label: "Send SMS", className: "sendSMSIcon" },
        {
          to: "/home/sendEmail",
          label: "Send Email",
          className: "sendEmailIcon",
        },
        {
          to: "/home/webEnquiries",
          label: "Web Enquiries",
          className: "webEnquiries",
        },
        {
          to: "/home/notification",
          label: "Push Notification",
          className: "pushIcon",
        },
      ],
    },
    {
      title: "Financial Reports",
      children: [
        {
          to: "/home/dailyActivity",
          label: "Daily Activity",
          className: "webEnquiries",
        },
      ],
    },
  ];

  const toggleSection = (title) => {
    setOpenSections((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <ul className="sidebar">
      {menuItems.map((section) => (
        <li key={section.title}>
          <div
            className="sidebar-category"
            onClick={() => toggleSection(section.title)}
          >
            <span className="title">{section.title}</span>
            <span className="arrow">
              {openSections[section.title] ? "▲" : "▼"}
            </span>
          </div>
          {openSections[section.title] && (
            <ul className="submenu">
              {section.children.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={item.className}
                    activeClassName="active"
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
}

export default SidebarMenu;
